import { Version } from 'app/zdslogic-ui-shell/@fuse/version/version';

export const FUSE_VERSION = new Version('15.1.0').full;
